"use client";

import React from "react";
import { VideoControlService } from "./VideoControlService";

interface VideoControlControllerProps { }

export const VideoControlController = (props: VideoControlControllerProps): null =>
{
    React.useEffect(() =>
    {
        const services = Array.from(document.querySelectorAll<HTMLElement>("[data-logic-feature='video-controls']")).map(element => new VideoControlService(element));

        return () =>
        {
            services.forEach(controller => controller.dispose());
        };
    }, []);

    return null;
};